import { cva } from 'class-variance-authority';

// These variants act as a workaround for the different button
// variants and inconsistencies in how they treat border widths.
export const buttonVariants = cva('', {
  variants: {
    size: {
      medium: 'size-sizing-comp-stepper-medium',
      small: 'size-sizing-comp-stepper-small',
      tiny: 'size-sizing-comp-stepper-tiny',
    },
  },
});
